import { Capacitor } from '@capacitor/core';

const NATIVE_PREVIEW_KEY = 'fixnow:native-preview';

/**
 * 是否套用原生 App 介面。
 * 開發模式可在瀏覽器 Console 執行 localStorage.setItem('fixnow:native-preview', '1') 後重新整理預覽；
 * 正式網頁版 build 不會讀取此開關。
 */
export const isNativeUi = (): boolean => {
  if (Capacitor.isNativePlatform()) return true;
  if (!import.meta.env.DEV) return false;
  try {
    return localStorage.getItem(NATIVE_PREVIEW_KEY) === '1';
  } catch {
    return false;
  }
};
